export enum ChangeInvestmentInstructionSubmissionTypeEnum {
  Rebalance,
  AdjustFutureContributions
}
